<template>
	<span class="text-danger" v-if="formName.errors.has(propName)" v-text="formName.errors.get(propName)"></span>
</template>

<script>
	export default {
		props:['formName','propName']
	}
</script>